import { EventEmitter, Injectable, signal } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TokenStorageService } from './token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SubscribersService {

  isUserLoggedIn: Subject<boolean> = new Subject<boolean>();
  private verificationTabFormSubject = new BehaviorSubject<any>(null);
  public verificationTabForm = this.verificationTabFormSubject.asObservable();
  getCountFormLocalStorage: Subject<any> = new Subject<any>();
  getCreditFormLocalStorage: Subject<any> = new Subject<any>();
  headerCreditCountUpdate: Subject<boolean> = new Subject<boolean>();
  surfaceAccessoriesData: Subject<any> = new Subject<any>();
  accessorySizeChange: EventEmitter<number> = new EventEmitter<number>();
  recalculateQuoteEvent: EventEmitter<any> = new EventEmitter<any>();
  selectedQuote: any = signal(null);
  familyDropdownChange: any = signal(null);
  sampleOrderError: any = signal(false);
  accessorySizeId: any = signal(null);
  sampleOrders: any = signal([]);
  tabScroll: Subject<any> = new Subject<any>();
  requestSample: Subject<any> = new Subject<any>();
  isRequestSampleOpen: any = signal(false);
  isProductDetailPageSubject: Subject<any> = new Subject<any>();
  public isProductDetailPage = this.isProductDetailPageSubject.asObservable();
  carrierJobStatus: any = signal(null);

  constructor(private tokenStorageService: TokenStorageService) {
    this.sampleOrders.set(this.tokenStorageService.getSampleOrder());
  }

  /**
   * This method is used to set the current status of user
   * @param status
   */
  setUserLoggedInStatus(status: boolean) {
    this.isUserLoggedIn.next(status);
  }

  /**
   * This method is used to set the data of register form
   * @param data
   */
  verificationFormToggle(data: any) {
    this.verificationTabFormSubject.next(data);
  }

  getCountFromLocalStorageToggle(flag: boolean) {
    this.getCountFormLocalStorage.next(flag)
  }

  getCreditEarnFormLocalStorage(flag: boolean) {
    this.getCreditFormLocalStorage.next(flag)
  }

  headerCreditCountUpdateToggle(flag: boolean) {
    this.headerCreditCountUpdate.next(flag);
  }

  setSurfaceAccessoriesData(data: any) {
    this.surfaceAccessoriesData.next(data);
  }

  emitAccessorySizeChange(data: any) {
    this.accessorySizeChange.emit(data);
  }

  scrollTo(id: any) {
    this.tabScroll.next(id);
  }

  addToSampleOrder(status: any) {
    this.requestSample.next(status);
  }

  setProductDetailPage(flag: any) {
    this.isProductDetailPageSubject.next(flag);
  }
}
